<template xmlns="http://www.w3.org/1999/html">
    <div id="new-waba-channel-form">
        <a-form>
            <div class="form-wrapper">
                <div class="input-wrapper">
                    <label>{{ $t("whatsappChannel.channelName") }}</label>
                    <a-form-item
                        :validate-status="getErrorStatus('channelName')"
                        :help="getErrorMessage('channelName')"
                    >
                        <a-input
                            v-model="form.channelName"
                            :placeholder="$t('whatsappChannel.channelName')"
                            name="channelName"
                            ref="channelName"
                        />
                    </a-form-item>
                </div>

                <div class="input-wrapper">
                    <label>{{ $t("whatsapp_business_api.phoneNumberE164") }}</label>
                    <a-input
                        :placeholder="$t('whatsapp_business_api.phoneNumberE164Place')"
                        v-model="form.phoneNumber"
                        v-validate="'required'"
                        name="phoneNumber"
                    />
                </div>
                <div class="input-wrapper">
                    <div class="mt-1 mb-1">
                        <a-switch :checked="!!form.forward.story" @click="toggleChatbot" />
                        <span>👉 {{ $t("whatsappChannel.forwardToChatbot") }}</span>
                    </div>
                    <label>{{ $t("whatsappChannel.forwardingChatbotOrLiveAgent") }}</label>
                    <a-select
                        v-model="form.forward.story"
                        @change="handleStoryChange"
                        :defaultValue="null"
                        notFoundContent="👉 Forward Live Agents"
                        :disabled="!showStories"
                    >
                        <a-select-option :selected="true" :value="null"> 👉 Forward Live Agents</a-select-option>
                        <a-select-option :key="story._id" v-for="story in stories" :value="story._id">
                            {{ story.title }}
                        </a-select-option>
                    </a-select>
                    <br />
                    <label>Departmana Yönlendirme</label>
                    <a-select v-model="form.forward.department" @change="getSubjectTitle" :defaultValue="null">
                        <a-select-option :selected="true" :value="null">👉Selected Department...</a-select-option>
                        <a-select-option :key="department._id" v-for="department of subjects" :value="department._id">
                            {{ getSubjectTitle(department) }}
                        </a-select-option>
                    </a-select>
                </div>
                <VisibilityChanger v-model="form.visibility" />
            </div>
        </a-form>

        <div class="form-footer">
            <div class="actions">
                <a-button @click="handleCancel">{{ $t("billing.cancel") }}</a-button>
                <a-button class="pr-confirm-btn" @click="handleSave" type="primary" :disabled="loading">
                    {{ $t("billing.save") }}
                </a-button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { sendSocketMessage } from "../../../utils/socketStream";
import _ from "lodash";
import VisibilityChanger from "../WhatsappV1/VisibilityChanger.vue";

export default {
    name: "NewMultiWhatsappChannel",
    components: { VisibilityChanger },
    data() {
        return {
            showStories: false,
            form: {
                channelName: "",
                phoneNumber: "",
                visibility: {
                    users: [],
                    departments: [],
                },
                forward: {
                    department: null,
                    story: null,
                    mode: "live",
                    hybrid: {
                        department: null,
                    },
                },
            },
            loading: false,
            submitClicked: false,
        };
    },
    computed: {
        ...mapState({
            stories: (state) => state.CB.stories,
            siteId: (state) => _.get(state.site.site, "_id"),
            subjects: (state) => _.get(state.subject.subjects, "data", []) || [],
        }),
    },
    methods: {
        ...mapActions({
            createChannel: "channel/createChannel",
        }),
        getErrorStatus(fieldName) {
            return this.form[fieldName].length < 1 && this.submitClicked ? "error" : "";
        },
        getErrorMessage(fieldName) {
            return this.form[fieldName].length < 1 && this.submitClicked ? this.$t("message.requiredChannel") : "";
        },
        toggleChatbot() {
            if (this.showStories) {
                this.form.forward.story = null;
                this.form.forward.mode = "live";
            } else {
                if (this.stories[0]) {
                    this.form.forward.story = this.stories[0]._id;
                    this.form.forward.mode = "chatbot";
                }
            }
            this.showStories = !this.showStories;
        },
        handleStoryChange() {},
        getSubjectTitle(department) {
            const validLangs = Object.keys(department.languageContent);
            const targetLang = validLangs.includes(this.$i18n.locale) ? this.$i18n.locale : validLangs[0];
            const key = `languageContent.${targetLang}.name`;
            return _.get(department, key);
        },
        handleCancel() {
            this.$emit("cancel");
        },
        handleSave() {
            this.submitClicked = true;
            if (this.form.channelName.length < 1) {
                this.$refs.channelName.focus();
                return;
            } else {
                const isValid = true;
                if (isValid) {
                    const payload = {
                        type: "whatsapp-v2",
                        name: this.form.channelName,
                        visibility: this.form.visibility,
                        payload: {
                            phoneNumber: this.form.phoneNumber,
                        },
                        forward: this.form.forward,
                    };
                    this.loading = true;
                    this.createChannel(payload)
                        .then(() => {
                            this.$message.success(this.$t("message.channelCreatedSuccessfully"));
                            sendSocketMessage("user wp-channel-created", {
                                siteId: this.siteId,
                            });
                            this.$emit("ok", payload);
                        })
                        .catch((err) => {
                            this.$message.error("Failed to create channel");
                        })
                        .finally(() => {
                            this.loading = false;
                            this.$router.replace("/integrations/whatsapp-v2");
                        });
                }
            }
        },
    },
    mounted() {},
    beforeDestroy() {},
};
</script>

<style lang="scss" scoped>
#new-waba-channel-form {
    min-height: 250px;
    flex-direction: column;

    .form-wrapper {
        padding: 20px;
        display: flex;
        flex-direction: column;
        gap: 10px;

        .input-wrapper {
            display: flex;
            flex-direction: column;
            gap: 5px;
        }
    }

    .form-footer {
        display: flex;
        justify-content: flex-end;
        padding: 10px;
        margin-top: 20px;
        background: var(--color-bg-default);
        border-top: 1px solid var(--color-border-default);
    }
}
</style>

<style lang="scss">
.new-waba {
    .custom-modal-body {
        padding: 0px !important;
    }
}
</style>
